module.exports = __webpack_public_path__ + "static/media/stm-data.46a84d06.svg";